import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table bets report view.
 * @extends JetView
 */
export default class tableBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter
        var direction = false; // Sorting direction flag
        var vthis = this; // Reference to the current instance

        // Custom data filter for summing tree column values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Sum result
                    var resultFormat = 0; // Formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending existing summColumn filter
        );

        // Custom data filter for summing column values in a paginated datatable
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Sum result
                    var resultFormat = 0; // Formatted result
                    var size = $$('datatable2').getPager().config.size; // Current page size
                    var page = $$('datatable2').getPage(); // Current page number
                    var first = size * page; // First item index on the current page
                    var last = first + size - 1; // Last item index on the current page
                    var count = 0; // Counter for items

                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Summing values within the current page
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Formatting result
                    node.firstChild.innerHTML = resultFormat; // Updating node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending existing summColumn filter
        );

        // Returning the layout configuration for the view
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Main datatable for bets report
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                // Data scheme can be defined here
                            },
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 200, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            // Check if the row is a group
                                            return (
                                                common.datatable(obj, common) + obj.value // Return group value
                                            );
                                        return obj.Date; // Return date value
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text with localization
                                    template: function (obj) {
                                        if (obj.$level == 1) {
                                            return ''; // No details icon for level 1
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Details icon for other levels
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Ticket Id'), // Column header with localization
                                    width: 100, // Column width
                                },
                                {
                                    id: 'BetShop', // Column ID
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'DatePayment', // Column ID
                                    header: _('Fecha de pago'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'BetShopPayment', // Column ID
                                    header: _('Punto Venta Pagó'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Cashier', // Column ID
                                    header: _('Cajero'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('Usuario Id'), // Column header with localization
                                    width: 80, // Column width
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Usuario'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    width: 80, // Column width
                                    options: [
                                        { id: 'C', value: _('Abierto') }, // Open state
                                        { id: 'S', value: _('Ganó') }, // Won state
                                        { id: 'N', value: _('Perdió') }, // Lost state
                                        { id: 'A', value: _('No Acción') }, // No action state
                                        { id: 'R', value: _('Pendiente') }, // Pending state
                                        { id: 'W', value: _('En Espera') }, // Waiting state
                                        { id: 'J', value: _('Rechazada') }, // Rejected state
                                        {
                                            id: 'M',
                                            value: _('Rechazada por Regla'), // Rejected by rule state
                                        },
                                        {
                                            id: 'T',
                                            value: _('Retiro Voluntario'), // Voluntary withdrawal state
                                        },
                                    ],
                                },
                                {
                                    id: 'ClosingDate', // Column ID
                                    header: _('Fecha Cierre'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WinningAmount', // Column ID
                                    header: _('Premios'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'Tax', // Column ID
                                    header: _('Impuesto Premios'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'TaxBet', // Column ID
                                    header: _('Impuesto Apuesta'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WinningAmountTotal', // Column ID
                                    header: _('Premio Total'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                { id: 'Odds', header: _('Odds'), width: 100 }, // Odds column
                                { id: 'UserIP', header: 'IP', width: 150 }, // User IP column
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        item.Id, // Trigger user ID event
                                    ]);
                                    $$('dColl').expand(); // Expand details section
                                    $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay before data load
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            url: devConfig.geturlApi() + 'null/Report/GetBetHistory', // Data source URL
                        },
                        {
                            view: 'treetable', // Secondary treetable for detailed report
                            id: 'datatable2', // Unique ID for the treetable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 260, // Column width
                                    format: dateFormat, // Date formatting function
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            // Check if the row is a group
                                            return (
                                                common.treetable(obj, common) + obj.value // Return group value
                                            );
                                        return obj.Date; // Return date value
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text with localization
                                    template: function (obj) {
                                        if (obj.$level < 5) {
                                            return ''; // No details icon for levels less than 5
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Details icon for level 5 and above
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Ticket Id'), // Column header with localization
                                    width: 100, // Column width
                                },
                                {
                                    id: 'BetShop', // Column ID
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 170, // Column width
                                },
                                {
                                    id: 'DatePayment', // Column ID
                                    header: _('Fecha de pago'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'BetShopPayment', // Column ID
                                    header: _('Punto Venta Pagó'), // Column header with localization
                                    width: 160, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Cashier', // Column ID
                                    header: _('Cajero'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('Usuario Id'), // Column header with localization
                                    width: 80, // Column width
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Usuario'), // Column header with localization
                                    width: 200, // Column width
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    width: 80, // Column width
                                    options: [
                                        { id: 'C', value: _('Abierto') }, // Open state
                                        { id: 'S', value: _('Ganó') }, // Won state
                                        { id: 'N', value: _('Perdió') }, // Lost state
                                        { id: 'A', value: _('No Acción') }, // No action state
                                        { id: 'R', value: _('Pendiente') }, // Pending state
                                        { id: 'W', value: _('En Espera') }, // Waiting state
                                        { id: 'J', value: _('Rechazada') }, // Rejected state
                                        {
                                            id: 'M',
                                            value: _('Rechazada por Regla'), // Rejected by rule state
                                        },
                                        {
                                            id: 'T',
                                            value: _('Retiro Voluntario'), // Voluntary withdrawal state
                                        },
                                    ],
                                },
                                {
                                    id: 'CurrencyId', // Column ID
                                    header: _('Moneda'), // Column header with localization
                                    width: 100, // Column width
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 120, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'WinningAmount', // Column ID
                                    header: _('Premios'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 120, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'Tax', // Column ID
                                    header: _('Impuesto Premios'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 120, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'TaxBet', // Column ID
                                    header: _('Impuesto Apuesta'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 120, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'WinningAmountTotal', // Column ID
                                    header: _('Premio Total'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 120, // Column width
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                { id: 'Odds', header: _('Odds'), width: 100 }, // Odds column
                                { id: 'UserIP', header: 'IP', width: 150 }, // User IP column
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        item.Id, // Trigger user ID event
                                    ]);
                                    $$('dColl').expand(); // Expand details section
                                    $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay before data load
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: {
                                size: 10000, // Pager size
                                id: 'pagerA2', // Pager ID
                            },
                            url: devConfig.geturlApi() + 'null/Report/GetBetHistory2?FromId=' + cur_user + '&', // Data source URL
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The main datatable instance.
     */
    init(grid) {
        var gridppal = $$('datatable'); // Main datatable instance
        var grid2 = $$('datatable2'); // Secondary datatable instance
        $$('toolbar2').hide(); // Hide secondary toolbar
        grid2.hide(); // Hide secondary datatable
        var url = gridppal.data.url; // Data source URL
        const _ = this.app.getService('locale')._; // Localization service
        var flag = false; // Flag for export operation
        const cur_user = this.getParam('user', true); // Current user parameter

        // Event handler for after loading data in the secondary datatable
        grid2.attachEvent('onAfterLoad', function () {
            $$('datatable2').data.group({
                by: 'UserName', // Group by UserName
                map: {
                    UserId: ['UserId'], // Mapping UserId
                    Date: ['UserName'], // Mapping Date
                    Partner: ['Partner'], // Mapping Partner
                    Country: ['Country'], // Mapping Country
                    CountryIcon: ['CountryIcon'], // Mapping CountryIcon
                    CurrencyId: ['CurrencyId'], // Mapping CurrencyId
                    Amount: ['Amount', 'sum'], // Summing Amount
                    WinningAmount: ['WinningAmount', 'sum'], // Summing WinningAmount
                    Tax: ['Tax', 'sum'], // Summing Tax
                    WinningAmountTotal: ['WinningAmountTotal', 'sum'], // Summing WinningAmountTotal
                },
            });
            $$('datatable2').data.group({
                by: 'CurrencyId', // Group by CurrencyId
                map: {
                    Partner: ['Partner'], // Mapping Partner
                    Country: ['Country'], // Mapping Country
                    CountryIcon: ['CountryIcon'], // Mapping CountryIcon
                    CurrencyId: ['CurrencyId'], // Mapping CurrencyId
                    Amount: ['Amount', 'sum'], // Summing Amount
                    WinningAmount: ['WinningAmount', 'sum'], // Summing WinningAmount
                    Tax: ['Tax', 'sum'], // Summing Tax
                    WinningAmountTotal: ['WinningAmountTotal', 'sum'], // Summing WinningAmountTotal
                },
            });
            $$('datatable2').data.group({
                by: function (obj) {
                    return (
                        "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Country // Group by Country with icon
                    );
                },
                map: {
                    Partner: ['Partner'], // Mapping Partner
                    Country: ['Country'], // Mapping Country
                    CountryIcon: ['CountryIcon'], // Mapping CountryIcon
                    Amount: ['Amount', 'sum'], // Summing Amount
                    WinningAmount: ['WinningAmount', 'sum'], // Summing WinningAmount
                    Tax: ['Tax', 'sum'], // Summing Tax
                    WinningAmountTotal: ['WinningAmountTotal', 'sum'], // Summing WinningAmountTotal
                },
            });
            $$('datatable2').data.group({
                by: function (obj) {
                    return "<i class='partner " + obj.Partner + "'></i>"; // Group by Partner with icon
                },
                map: {
                    Partner: ['Partner'], // Mapping Partner
                    Amount: ['Amount', 'sum'], // Summing Amount
                    WinningAmount: ['WinningAmount', 'sum'], // Summing WinningAmount
                    Tax: ['Tax', 'sum'], // Summing Tax
                    WinningAmountTotal: ['WinningAmountTotal', 'sum'], // Summing WinningAmountTotal
                },
            });
        });

        var filter = ''; // Filter string
        // Event handler for filtering data based on user input
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for date filters
            var string2 = ''; // Query string for sorting
            var providergroup = 0; // Provider group flag

            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'IsDetails') {
                    if (object[i][1] == 0) {
                    } else {
                        providergroup = 1; // Set provider group flag
                    }
                }
                if (object[i][0] == 'Sort') {
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[Date]='; // Sort by Date
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[UserId]='; // Sort by UserId
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Amount]='; // Sort by Amount
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir') {
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'DateStart') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] == 'DateEnd') {
                            var date = object[i][1].split(' - '); // Split date range
                            console.log(date);
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query
                        } else {
                            if (object[i][0] != 'Sort' && object[i][0] != 'Dir') {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (providergroup == 0) {
                gridppal.show(); // Show main datatable
                grid2.hide(); // Hide secondary datatable
                gridppal.clearAll(); // Clear main datatable
                gridppal.load(
                    url + '?start=0&count=' + gridppal.data.$pagesize + string1 + string2 + '&FromId=' + cur_user, // Load data with filters
                );
                $$('toolbar').show(); // Show main toolbar
                $$('toolbar2').hide(); // Hide secondary toolbar
            } else {
                grid2.show(); // Show secondary datatable
                gridppal.hide(); // Hide main datatable
                grid2.clearAll(); // Clear secondary datatable
                grid2.load(
                    url + '?start=0&count=' + grid2.data.$pagesize + string1 + string2 + '&FromId=' + cur_user, // Load data with filters
                );
                grid2.adjust(); // Adjust secondary datatable
                $$('toolbar2').show(); // Show secondary toolbar
                $$('toolbar').hide(); // Hide main toolbar
            }
            filter = string1 + string2 + '&FromId=' + cur_user; // Update filter string
        });

        // Event handler for sorting data in the main datatable
        gridppal.attachEvent('onAfterSort', function (by, dir, as) {
            gridppal.load(
                url + '?start=0&count=' + gridppal.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click in the main datatable
        gridppal.attachEvent('onItemClick', function (id, e, node) {});

        // Event handler for player selection
        this.on(this.app, 'player:select', (id) => {
            gridppal.load(
                gridppal.data.url + '?start=0&count=' + gridppal.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });

        // Event handler for export filter
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set export flag
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first; // Use original first index
            }
            gridppal.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            gridppal.attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        var size = gridppal.getPager().config.size; // Get pager size
                        var page = gridppal.getPage(); // Get current page number
                        var first = size * page; // First item index on the current page
                        var last = first + size - 1; // Last item index on the current page
                        if ($$('Export').getValue() == '1') {
                            for (var j = 0; j < gridppal.config.columns.length; j++) {
                                if (gridppal.config.columns[j].exportType) {
                                    delete gridppal.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Apuestas') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name
                                    TypeReport: 'Excel', // Report type
                                },
                            ]);
                            webix.toExcel(gridppal, {
                                filter: function (obj) {
                                    return (
                                        gridppal.getIndexById(obj.id) >= first && gridppal.getIndexById(obj.id) <= last // Filter for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Apuestas'), // Filename for export
                                ignore: { detailTittle: true }, // Ignore detail title in export
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Apuestas') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(), // Report name
                                        TypeReport: 'PDF', // Report type
                                    },
                                ]);
                                webix.toPDF(gridppal, {
                                    filter: function (obj) {
                                        return (
                                            gridppal.getIndexById(obj.id) >= first &&
                                            gridppal.getIndexById(obj.id) <= last // Filter for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Apuestas'), // Filename for export
                                    autowidth: true, // Auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export').setValue(''); // Reset export selection
                    }
                }.bind(this), // Bind context for event handler
            );
        });
    }
}

// FILE DOCUMENTED
